<template>
  <div id="app" class="body">
    <router-view :key="$route.fullPath"/>
    <ChatModel></ChatModel>
  </div>
</template>

<script>
import ChatModel from './components/chat/ChatModel.vue';

export default {
  components: {ChatModel},
  name: 'App',
}
</script>

<style>
#app {
  height: 100%;
}
@media (max-width:900px) {
  .body{
      min-height: 100vh;
  }

}
</style>
